import {
  handleThumbnailDrawer,
  pdfStore,
  usePdfViewerStore,
} from "@/slices/pdfViewer";
import { Box, Drawer, Stack } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import AttachmentViewer from "./attachments-viewer";
import ThumbnailRender from "./thumbnail-render";

export default function ThumbNailViewer() {
  const open = usePdfViewerStore((state) => state.thumbDrawerOpen);
  const currentDocument = pdfStore.getState().document;
  const isThumbnailsRendered = useRef(false);
  const [pages, setPages] = useState([]);

  useEffect(() => {
    async function getPages() {
      const totalPages = currentDocument.numPages;
      for (let index = 1; index <= totalPages; index++) {
        try {
          const page = await currentDocument.getPage(index);
          setPages((prev) => [...prev, page]);
        } catch (error) {
          console.log("Error when rendering thumbnails", error);
        }
      }
      isThumbnailsRendered.current = true;
    }
    if (currentDocument != null && isThumbnailsRendered.current === false) {
      getPages();
    }
  }, [currentDocument]);

  return (
    <Drawer
      variant="temporary"
      ModalProps={{
        container: document.getElementById("pdf-container"),
        className: "absolute",
      }}
      slotProps={{
        backdrop: {
          className: "absolute",
        },
        paper: { className: "absolute" },
      }}
      open={open}
      onClose={handleThumbnailDrawer}
    >
      <Stack className="relative w-full gap-2">
        <Box className="fixed w-[158px] p-4">
          <AttachmentViewer />
        </Box>
        <Stack className="mt-12 gap-2 p-4">
          {pages.map((page, index) => (
            <ThumbnailRender key={index} page={page} />
          ))}
        </Stack>
      </Stack>
    </Drawer>
  );
}
